{
  "searchPostcodeOrAddress": "Search ZIP code or address",
  "addressForm": {
    "labels": {
      "address3": "City",
      "address4": "State",
      "postcode": "ZIP Code"
    },
    "placeholders": {
      "addressName": "Example: Example Solutions Inc",
      "address3": "Example: New York",
      "address4": "Example: NY",
      "postcode": "Example: 10001"
    }
  }
}
